<script lang="ts" setup>
export interface VydavokProps {
  vydavky: object
  kategoria: object
  pos: number
}

import { watch, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRozpocetStore } from '/@src/stores/rozpocet'
import { computed } from 'vue-demi'
import { formatMoney } from '/@src/utils/moneyFormatter'
const { t } = useI18n()

const props = defineProps<VydavokProps>()

const druhPolozky = computed(
  () => props.kategoria?.kategoriaVydavku
)

const rozpocetStore = useRozpocetStore()
const vydavkyStore = rozpocetStore.getStoreByDruh(druhPolozky.value)

const polozky = computed(() => vydavkyStore.polozky)
const polozkyIds = computed(() => vydavkyStore.polozkyIds)
const canRemoveExpense = computed(() => polozkyIds.value.length > 1)

const sumaZaVysetkyVydavky = computed(() =>
  formatMoney(vydavkyStore.sumaZaVsetkyVydavky)
)

const addExpense = () => {
  vydavkyStore.addBlankPolozka()
}

const removeExpense = (polozkaId: string) => {
  vydavkyStore.removePolozka(polozkaId)
}

const expanded = ref<boolean>(false)

watch(polozky, () => {
  expanded.value = polozky.value?.some(
    (p) => p.nazov || Object.values(p.checkboxesState).filter(Boolean)?.length
  )
})
</script>

<template>
  <IDSKAccordionSection
    show-control
    :expanded="expanded"
    @expand="expanded = true"
    @close="expanded = false"
    v-if="props.kategoria?.povolene"
  >
    <template #heading>
      {{
        t(`zoppm.step9.${vydavky.druhVydavku}.${druhPolozky}.accordionTitle`)
      }}
    </template>

    <template #headingRight>
      {{ t(`zoppm.step9.${vydavky.druhVydavku}.${druhPolozky}.accordionInfo`) }}
      {{ sumaZaVysetkyVydavky }}
    </template>

    <VydavokProjektu
      v-for="(polozkaId, idx) in polozkyIds"
      :key="polozkaId"
      :polozka-id="polozkaId"
      :can-remove-expense="canRemoveExpense"
      :druh-polozky="druhPolozky"
      :zdroje-financovania="props.kategoria?.zdrojeFinancovania"
      @remove="removeExpense"
    >
      <template #divider>
        <IDSKDivider v-if="idx > 0" class="mt-8 mb-8" />
      </template>
    </VydavokProjektu>

    <div>
      <button class="idsk-button idsk-button--secondary" @click.prevent="addExpense()">
        {{ t('zoppm.step9.addExpense') }}
      </button>
    </div>
  </IDSKAccordionSection>
</template>

<style scoped></style>
